import React from "react"
import Accord from "url:assets/images/lenders/Accord.png"
import AIB from "url:assets/images/lenders/AIB.png"
import AldermoreMortgages from "url:assets/images/lenders/Aldermore Mortgages.png"
import Atom from "url:assets/images/lenders/Atom Bank.png"
import BankOfIreland from "url:assets/images/lenders/Bank of Ireland.png"
import Barclays from "url:assets/images/lenders/Barclays Bank.png"
import BathBuildingSociety from "url:assets/images/lenders/Bath Building Society.png"
import BeverleyBuildingSociety from "url:assets/images/lenders/Beverley Building Society.png"
import BirminghamMidshires from "url:assets/images/lenders/Birmingham Midshires.png"
import BluestoneMortgages from "url:assets/images/lenders/Bluestone Mortgages.png"
import BMSolutions from "url:assets/images/lenders/BM Solutions.png"
import CambridgeBuildingSociety from "url:assets/images/lenders/Cambridge Building Society.png"
import ChorleyBuildingSociety from "url:assets/images/lenders/Chorley Building Society.png"
import ClydesdaleBank from "url:assets/images/lenders/Clydesdale Bank.png"
import CoventryBuildingSociety from "url:assets/images/lenders/Coventry Building Society.png"
import DigitalMortgages from "url:assets/images/lenders/Digital Mortgages.png"
import FoundationHomeLoans from "url:assets/images/lenders/Foundation Home Loans.png"
import FurnessBuildingSociety from "url:assets/images/lenders/Furness Building Society.png"
import GenerationHome from "url:assets/images/lenders/Generation Home.png"
import GodivaMortgages from "url:assets/images/lenders/Godiva Mortgages.png"
import Halifax from "url:assets/images/lenders/Halifax.png"
import HinckleyandRugbyBuildingSociety from "url:assets/images/lenders/Hinckley and Rugby Building Society.png"
import HSBC from "url:assets/images/lenders/HSBC.png"
import KensingtonMortgages from "url:assets/images/lenders/Kensington Mortgages.png"
import KentReliance from "url:assets/images/lenders/Kent Reliance.png"
import Landbay from "url:assets/images/lenders/Landbay.png"
import LeedsBuildingSociety from "url:assets/images/lenders/Leeds Building Society.png"
import LeekUnitedBuildingSociety from "url:assets/images/lenders/Leek United Building Society.png"
import LloydsBank from "url:assets/images/lenders/Lloyds Bank.png"
import MansfieldBuildingSociety from "url:assets/images/lenders/Mansfield Building Society.png"
import MetroBank from "url:assets/images/lenders/Metro Bank.png"
import MeltonBuildingSociety from "url:assets/images/lenders/Melton Building Society, The.png"
import MonmouthshireBuildingSociety from "url:assets/images/lenders/Monmouthshire Building Society.png"
import MortgageWorks from "url:assets/images/lenders/Mortgage Works, The.png"
import NationwideBuildingSociety from "url:assets/images/lenders/Nationwide Building Society.png"
import Natwest from "url:assets/images/lenders/Natwest.png"
import NewcastleBuildingSociety from "url:assets/images/lenders/Newcastle Building Society.png"
import NewburyBuildingSociety from "url:assets/images/lenders/Newbury Building Society.png"
import NottinghamBuildingSociety from "url:assets/images/lenders/Nottingham Building Society.png"
import ParagonBank from "url:assets/images/lenders/Paragon Banking Group PLC.png"
import PepperMoney from "url:assets/images/lenders/Pepper Money.png"
import Platform from "url:assets/images/lenders/Platform.png"
import PostOffice from "url:assets/images/lenders/Post Office.png"
import PreciseMortgages from "url:assets/images/lenders/Precise Mortgages.png"
import Principality from "url:assets/images/lenders/Principality BS.png"
import ProgressiveBuildingSociety from "url:assets/images/lenders/Progressive Building Society.png"
import RBS from "url:assets/images/lenders/Royal Bank of Scotland.png"
import Santander from "url:assets/images/lenders/Santander UK PLC.png"
import ScottishWidowsBank from "url:assets/images/lenders/Scottish Widows Bank.png"
import SkiptonBuildingSociety from "url:assets/images/lenders/Skipton Building Society.png"
import Together from "url:assets/images/lenders/Together.png"
import TSB from "url:assets/images/lenders/TSB.png"
import VidaHomeloans from "url:assets/images/lenders/Vida Homeloans.png"
import VirginMoney from "url:assets/images/lenders/Virgin Money.png"

import AccordWhite from "url:assets/images/lenders/white/Accord.png"
import AldermoreMortgagesWhite from "url:assets/images/lenders/white/Aldermore Mortgages.png"
import AtomWhite from "url:assets/images/lenders/white/Atom Bank.png"
import BankOfIrelandWhite from "url:assets/images/lenders/white/Bank of Ireland.png"
import BarclaysWhite from "url:assets/images/lenders/white/Barclays Bank.png"
import BathBuildingSocietyWhite from "url:assets/images/lenders/white/Bath Building Society.png"
import BeverleyBuildingSocietyWhite from "url:assets/images/lenders/white/Beverley Building Society.png"
import BirminghamMidshiresWhite from "url:assets/images/lenders/white/Birmingham Midshires.png"
import BluestoneMortgagesWhite from "url:assets/images/lenders/white/Bluestone Mortgages.png"
import BMSolutionsWhite from "url:assets/images/lenders/white/BM Solutions.png"
import CambridgeBuildingSocietyWhite from "url:assets/images/lenders/white/Cambridge Building Society.png"
import ChorleyBuildingSocietyWhite from "url:assets/images/lenders/white/Chorley Building Society.png"
import ClydesdaleBankWhite from "url:assets/images/lenders/white/Clydesdale Bank.png"
import CoventryBuildingSocietyWhite from "url:assets/images/lenders/white/Coventry Building Society.png"
import DigitalMortgagesWhite from "url:assets/images/lenders/white/Digital Mortgages.png"
import FoundationHomeLoansWhite from "url:assets/images/lenders/white/Foundation Home Loans.png"
import FurnessBuildingSocietyWhite from "url:assets/images/lenders/white/Furness Building Society.png"
import GenerationHomeWhite from "url:assets/images/lenders/white/Generation Home.png"
import GodivaMortgagesWhite from "url:assets/images/lenders/white/Godiva Mortgages.png"
import HalifaxWhite from "url:assets/images/lenders/white/Halifax.png"
import HinckleyandRugbyBuildingSocietyWhite from "url:assets/images/lenders/white/Hinckley and Rugby Building Society.png"
import HSBCWhite from "url:assets/images/lenders/white/HSBC.png"
import KensingtonMortgagesWhite from "url:assets/images/lenders/white/Kensington Mortgages.png"
import KentRelianceWhite from "url:assets/images/lenders/white/Kent Reliance.png"
import LandbayWhite from "url:assets/images/lenders/white/Landbay.png"
import LeedsBuildingSocietyWhite from "url:assets/images/lenders/white/Leeds Building Society.png"
import LeekUnitedBuildingSocietyWhite from "url:assets/images/lenders/white/Leek United Building Society.png"
import LloydsBankWhite from "url:assets/images/lenders/white/Lloyds Bank.png"
import MansfieldBuildingSocietyWhite from "url:assets/images/lenders/white/Mansfield Building Society.png"
import MetroBankWhite from "url:assets/images/lenders/white/Metro Bank.png"
import MeltonBuildingSocietyWhite from "url:assets/images/lenders/white/Melton Building Society, The.png"
import MonmouthshireBuildingSocietyWhite from "url:assets/images/lenders/white/Monmouthshire Building Society.png"
import MortgageWorksWhite from "url:assets/images/lenders/white/Mortgage Works, The.png"
import NationwideBuildingSocietyWhite from "url:assets/images/lenders/white/Nationwide Building Society.png"
import NatwestWhite from "url:assets/images/lenders/white/Natwest.png"
import NewcastleBuildingSocietyWhite from "url:assets/images/lenders/white/Newcastle Building Society.png"
import NewburyBuildingSocietyWhite from "url:assets/images/lenders/white/Newbury Building Society.png"
import NottinghamBuildingSocietyWhite from "url:assets/images/lenders/white/Nottingham Building Society.png"
import ParagonBankWhite from "url:assets/images/lenders/white/Paragon Banking Group PLC.png"
import PepperMoneyWhite from "url:assets/images/lenders/white/Pepper Money.png"
import PlatformWhite from "url:assets/images/lenders/white/Platform.png"
import PostOfficeWhite from "url:assets/images/lenders/white/Post Office.png"
import PreciseMortgagesWhite from "url:assets/images/lenders/white/Precise Mortgages.png"
import PrincipalityWhite from "url:assets/images/lenders/white/Principality BS.png"
import ProgressiveBuildingSocietyWhite from "url:assets/images/lenders/white/Progressive Building Society.png"
import RBSWhite from "url:assets/images/lenders/white/Royal Bank of Scotland.png"
import SantanderWhite from "url:assets/images/lenders/white/Santander UK PLC.png"
import ScottishWidowsBankWhite from "url:assets/images/lenders/white/Scottish Widows Bank.png"
import SkiptonBuildingSocietyWhite from "url:assets/images/lenders/white/Skipton Building Society.png"
import TogetherWhite from "url:assets/images/lenders/white/Together.png"
import TSBWhite from "url:assets/images/lenders/white/TSB.png"
import VidaHomeloansWhite from "url:assets/images/lenders/white/Vida Homeloans.png"
import VirginMoneyWhite from "url:assets/images/lenders/white/Virgin Money.png"

export const LenderIcon = ({ white, lenderName }: { white?: boolean; lenderName: string }) => {
  const lenderImagesRegular: Record<string, string> = {
    Accord: Accord,
    AIB: AIB,
    "Aldermore Mortgages": AldermoreMortgages,
    "Atom Bank": Atom,
    "Bank of Ireland": BankOfIreland,
    "Barclays Bank": Barclays,
    "Bath Building Society": BathBuildingSociety,
    "Beverley Building Society": BeverleyBuildingSociety,
    "Birmingham Midshires": BirminghamMidshires,
    "Bluestone Mortgages": BluestoneMortgages,
    "BM Solutions": BMSolutions,
    "Cambridge Building Society": CambridgeBuildingSociety,
    "Chorley Building Society": ChorleyBuildingSociety,
    "Clydesdale Bank": ClydesdaleBank,
    "Coventry Building Society": CoventryBuildingSociety,
    "Digital Mortgages": DigitalMortgages,
    "Foundation Home Loans": FoundationHomeLoans,
    "Furness Building Society": FurnessBuildingSociety,
    "Generation Home": GenerationHome,
    "Godiva Mortgages": GodivaMortgages,
    Halifax: Halifax,
    "Hinckley and Rugby Building Society": HinckleyandRugbyBuildingSociety,
    HSBC: HSBC,
    "Kensington Mortgages": KensingtonMortgages,
    "Kent Reliance": KentReliance,
    Landbay: Landbay,
    "Leeds Building Society": LeedsBuildingSociety,
    "Leek United Building Society": LeekUnitedBuildingSociety,
    "Lloyds Bank": LloydsBank,
    "Mansfield Building Society": MansfieldBuildingSociety,
    "Metro Bank": MetroBank,
    "Melton Building Society": MeltonBuildingSociety,
    "Monmouthshire Building Society": MonmouthshireBuildingSociety,
    "Mortgage Works": MortgageWorks,
    "Nationwide Building Society": NationwideBuildingSociety,
    Natwest: Natwest,
    "Newcastle Building Society": NewcastleBuildingSociety,
    "Newbury Building Society": NewburyBuildingSociety,
    "Nottingham Building Society": NottinghamBuildingSociety,
    "Paragon Bank": ParagonBank,
    "Pepper Money": PepperMoney,
    Platform: Platform,
    "Post Office": PostOffice,
    "Precise Mortgages": PreciseMortgages,
    Principality: Principality,
    "Progressive Building Society": ProgressiveBuildingSociety,
    "Royal Bank of Scotland": RBS,
    "Santander UK Plc": Santander,
    "Scottish Widows Bank": ScottishWidowsBank,
    "Skipton Building Society": SkiptonBuildingSociety,
    Together: Together,
    TSB: TSB,
    "Vida Homeloans": VidaHomeloans,
    "Virgin Money": VirginMoney,
  }

  const lenderImagesWhite: Record<string, string> = {
    Accord: AccordWhite,
    AIB: AIB,
    "Aldermore Mortgages": AldermoreMortgagesWhite,
    "Atom Bank": AtomWhite,
    "Bank of Ireland": BankOfIrelandWhite,
    "Barclays Bank": BarclaysWhite,
    "Bath Building Society": BathBuildingSocietyWhite,
    "Beverley Building Society": BeverleyBuildingSocietyWhite,
    "Birmingham Midshires": BirminghamMidshiresWhite,
    "Bluestone Mortgages": BluestoneMortgagesWhite,
    "BM Solutions": BMSolutionsWhite,
    "Cambridge Building Society": CambridgeBuildingSocietyWhite,
    "Chorley Building Society": ChorleyBuildingSocietyWhite,
    "Clydesdale Bank": ClydesdaleBankWhite,
    "Coventry Building Society": CoventryBuildingSocietyWhite,
    "Digital Mortgages": DigitalMortgagesWhite,
    "Foundation Home Loans": FoundationHomeLoansWhite,
    "Furness Building Society": FurnessBuildingSocietyWhite,
    "Generation Home": GenerationHomeWhite,
    "Godiva Mortgages": GodivaMortgagesWhite,
    Halifax: HalifaxWhite,
    "Hinckley and Rugby Building Society": HinckleyandRugbyBuildingSocietyWhite,
    HSBC: HSBCWhite,
    "Kensington Mortgages": KensingtonMortgagesWhite,
    "Kent Reliance": KentRelianceWhite,
    Landbay: LandbayWhite,
    "Leeds Building Society": LeedsBuildingSocietyWhite,
    "Leek United Building Society": LeekUnitedBuildingSocietyWhite,
    "Lloyds Bank": LloydsBankWhite,
    "Mansfield Building Society": MansfieldBuildingSocietyWhite,
    "Metro Bank": MetroBankWhite,
    "Melton Building Society": MeltonBuildingSocietyWhite,
    "Monmouthshire Building Society": MonmouthshireBuildingSocietyWhite,
    "Mortgage Works": MortgageWorksWhite,
    "Nationwide Building Society": NationwideBuildingSocietyWhite,
    Natwest: NatwestWhite,
    "Newcastle Building Society": NewcastleBuildingSocietyWhite,
    "Newbury Building Society": NewburyBuildingSocietyWhite,
    "Nottingham Building Society": NottinghamBuildingSocietyWhite,
    "Paragon Bank": ParagonBankWhite,
    "Pepper Money": PepperMoneyWhite,
    Platform: PlatformWhite,
    "Post Office": PostOfficeWhite,
    "Precise Mortgages": PreciseMortgagesWhite,
    Principality: PrincipalityWhite,
    "Progressive Building Society": ProgressiveBuildingSocietyWhite,
    "Royal Bank of Scotland": RBSWhite,
    "Santander UK Plc": SantanderWhite,
    "Scottish Widows Bank": ScottishWidowsBankWhite,
    "Skipton Building Society": SkiptonBuildingSocietyWhite,
    Together: TogetherWhite,
    TSB: TSBWhite,
    "Vida Homeloans": VidaHomeloansWhite,
    "Virgin Money": VirginMoneyWhite,
  }
  const lenderImages = white ? lenderImagesWhite : lenderImagesRegular

  const imageSrc = lenderImages[lenderName]

  if (imageSrc) {
    return <img src={imageSrc} alt={`Mortgage lender ${lenderName}`} style={{ width: "100px" }} />
  } else {
    return <></>
  }
}

export default LenderIcon
